/* unplugin-vue-components disabled */import script from "./rankItem.vue?vue&type=script&setup=true&lang=js"
export * from "./rankItem.vue?vue&type=script&setup=true&lang=js"

import "./rankItem.vue?vue&type=style&index=0&id=46609c12&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46609c12"]])

export default __exports__